module.exports = __webpack_public_path__ + "static/media/FontAwesome.0d2717cd.otf";